var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgTickets = function SvgTickets(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 5.25,
    x2: 10,
    y2: 18.75,
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.25,15 C3.90685425,15 5.25,13.6568542 5.25,12 C5.25,10.3431458 3.90685425,9 2.25,9 L2.25,6 C2.25,5.58578644 2.58578644,5.25 3,5.25 L21,5.25 C21.4142136,5.25 21.75,5.58578644 21.75,6 L21.75,9 C20.0931458,9 18.75,10.3431458 18.75,12 C18.75,13.6568542 20.0931458,15 21.75,15 L21.75,18 C21.75,18.4142136 21.4142136,18.75 21,18.75 L3,18.75 C2.58578644,18.75 2.25,18.4142136 2.25,18 L2.25,15 Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,5.25 L21,5.25 C21.4142136,5.25 21.75,5.58578644 21.75,6 L21.75,9 C20.0931458,9 18.75,10.3431458 18.75,12 C18.75,13.6568542 20.0931458,15 21.75,15 L21.75,18 C21.75,18.4142136 21.4142136,18.75 21,18.75 L10,18.75 L10,5.25 Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
var Memo = /*#__PURE__*/memo(SvgTickets);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "_/_/packages/moonlight/lib/assets/icons/tickets.5550c88d9cfdbeca14e49b2f208fc82d.svg";